import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import MarkdownDoc from '../content/MarkdownDoc';
import { getDocBySlug } from '../content/docsUtils';
import '../marketing/Marketing.css';

function HelpDocPage() {
  const { slug } = useParams();
  const doc = getDocBySlug(slug);

  useEffect(() => {
    if (doc) {
      document.title = `${doc.title} — Racontera Help`;
    } else {
      document.title = 'Page not found — Racontera Help';
    }
  }, [doc]);

  if (!doc) {
    return (
      <div className="doc-not-found">
        <h1>Page not found</h1>
        <p>
          <Link to="/help" className="doc-back">
            Back to help
          </Link>
        </p>
      </div>
    );
  }

  return (
    <article className="doc-page doc-page-app">
      <Link to="/help" className="doc-back">
        ← Back to help
      </Link>
      {doc.access === 'auth' && (
        <div className="docs-badge docs-badge-auth docs-badge-inline">Team only</div>
      )}
      <h1>{doc.title}</h1>
      {doc.excerpt && <p className="doc-excerpt">{doc.excerpt}</p>}
      <MarkdownDoc body={doc.body} />
    </article>
  );
}

export default HelpDocPage;
